import { featuredCategories, gridCategories } from "@/mocks/categories";
import type { Category } from "@/mocks/categories";

function FeaturedCard({ cat }: { cat: Category }) {
  return (
    <a
      href={cat.url}
      target="_blank"
      rel="noopener nofollow"
      className="group relative overflow-hidden rounded-2xl cursor-pointer h-full min-h-[320px]"
    >
      <img
        src={cat.imageUrlLarge}
        alt={`${cat.name} category on OOPBuy Spreadsheet`}
        className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-black/40 backdrop-blur-sm rounded-full text-white text-sm font-medium">
          {cat.name}
          <i className="ri-arrow-right-up-line text-xs"></i>
        </span>
      </div>
    </a>
  );
}

function GridCard({ cat }: { cat: Category }) {
  return (
    <a
      href={cat.url}
      target="_blank"
      rel="noopener nofollow"
      className="group relative overflow-hidden rounded-xl cursor-pointer bg-background-50 border border-background-200 hover:border-accent-300 transition-all duration-300"
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={cat.imageUrlSmall}
          alt={`${cat.name} spreadsheet guide on OOPBuy`}
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4">
        <h4 className="text-sm font-semibold text-foreground-900">{cat.name}</h4>
        <p className="mt-1 text-xs text-foreground-500">View Spreadsheet Guide</p>
      </div>
    </a>
  );
}

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-6 md:px-10 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            Curated Product Categories by{" "}
            <span className="text-accent-500">Spreadsheet</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Browse our organized product categories with detailed comparison spreadsheets for smarter buying decisions.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-5 mb-5">
          <div className="lg:w-1/2">
            <FeaturedCard cat={featuredCategories[0]} />
          </div>
          <div className="lg:w-1/2 flex flex-col gap-5">
            {featuredCategories.slice(1, 3).map((cat) => (
              <div key={cat.name} className="flex-1">
                <FeaturedCard cat={cat} />
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {gridCategories.map((cat) => (
            <GridCard key={cat.name} cat={cat} />
          ))}
        </div>
      </div>
    </section>
  );
}